module.exports = __webpack_public_path__ + "img/Downloadable-Reports.ddf6a9ba.svg";